import { Typography, Box } from '@mui/material';
import ContactAccordion from 'src/components/HelpInfo/ContactAccordion';
import Accordion from 'src/components/section/Accordion';
import AccordionList from 'src/components/HelpInfo/AccordionList';
import { QUALIFYING_TAX_AMNT } from 'src/constants/global';
import formatter from 'src/util/currencyFormatter';

const HomeHelpInfo = () => {
  return (
    <AccordionList>
      <ContactAccordion key="contactAccordion" />
      <Accordion key={'additionalInfoAccordion'} subtitle={`Additional Information`}>
        <Typography sx={{ marginY: '1rem' }}>
          {`If you are a business operating in Utah County you should have received a Confidential
  Annual Personal Property Tax Statement packet or short form in the mail. As required by
  Utah Statute 59-2-306, please declare all personal property owned, claimed, possessed,
  controlled, or managed by you at this location as of January 1 of the current year.
  Complete statement in detail and file with the Assessor's office by the due date listed
  on the Personal Property Tax Statement. All filings are subject to audit.`}
        </Typography>
        <Box sx={{ marginY: '1rem' }}>
          <Typography>
            {`Note: As required by Utah Statute (59-2-1115 4a) first calendar year taxpayers are
  required to file a signed statement and cannot skip to step 5. If the total aggregate
  taxable value is ${formatter.format(
    QUALIFYING_TAX_AMNT
  )} or less per county (Utah Statute - 59-2-1115 2a), the taxable
  tangible personal property is exempt from taxation and the taxpayer may elect to request
  the exemption by going directly to step 5. You must apply for the exemption each year`}
          </Typography>
        </Box>
      </Accordion>
    </AccordionList>
  );
};

export default HomeHelpInfo;
